export const STORAGE_KEY = "mixtape-recent-activity"
export const MAX_ITEMS = 8

export type RecentActivityItem = {
  id: string
  type: "song" | "radio"

  title: string
  artist: string

  image?: string

  playlistId?: string | number
  playlistTitle?: string
  playlistLink?: string

  songIndex?: number

  radioId?: string
  radioName?: string

  playedAt: number
}

export function getSongId(
  song: any,
  playlist: any,
  index: number,
) {
  return [
    playlist?.id ??
      playlist?.title ??
      "playlist",
    index,
    song?.songName ?? "",
    song?.songArtist ?? "",
  ].join("|")
}

export function formatRelativeTime(
  timestamp: number,
) {
  const diff = Date.now() - timestamp

  if (diff < 60_000) {
    return "Ahora"
  }

  const minutes = Math.floor(
    diff / 60_000,
  )

  if (minutes < 60) {
    return `Hace ${minutes} min`
  }

  const hours = Math.floor(
    minutes / 60,
  )

  if (hours < 24) {
    return `Hace ${hours} h`
  }

  const days = Math.floor(
    hours / 24,
  )

  if (days === 1) {
    return "Ayer"
  }

  if (days < 7) {
    return `Hace ${days} días`
  }

  return new Intl.DateTimeFormat(
    "es-ES",
    {
      day: "numeric",
      month: "short",
    },
  ).format(timestamp)
}

export function readRecentActivity(): RecentActivityItem[] {
  if (typeof window === "undefined") {
    return []
  }

  try {
    const raw =
      localStorage.getItem(STORAGE_KEY)

    if (!raw) {
      return []
    }

    const parsed = JSON.parse(raw)

    if (!Array.isArray(parsed)) {
      return []
    }

    return parsed
      .filter(
        (item) =>
          item &&
          typeof item.id === "string" &&
          typeof item.title === "string" &&
          typeof item.playedAt === "number",
      )
      .slice(0, MAX_ITEMS)
  } catch {
    return []
  }
}

export function saveRecentActivity(
  items: RecentActivityItem[],
) {
  if (typeof window === "undefined") {
    return
  }

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(
        items.slice(0, MAX_ITEMS),
      ),
    )
  } catch {
    // localStorage puede estar bloqueado.
  }
}